"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mixins = require("../mixins");
var _helpers = require("../helpers");
var _base = require("../themes/_base");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var displayTypes = {
  BLOCK: "block",
  INLINE: "inline",
  FLEX: "flex",
  INLINE_BLOCK: "inline-block",
  INLINE_FLEX: "inline-flex"
};
exports.displayTypes = displayTypes;
var propTypes = {
  d: _propTypes["default"].oneOf(Object.values(displayTypes)),
  w: _propTypes["default"].string,
  h: _propTypes["default"].string,
  minW: _propTypes["default"].string,
  maxW: _propTypes["default"].string,
  minH: _propTypes["default"].string,
  maxH: _propTypes["default"].string,
  /**
   * A valid css string to be used for the `flex` attribute
   * flex: "<grow> <shrink> <basis>"
   */
  flex: _propTypes["default"].string,
  /** How the items should wrap when in `flex` based display modes */
  wrap: _propTypes["default"].string,
  /** Direction of items in `flex` based display modes */
  direction: _propTypes["default"].oneOf(["row", "column", "row-reverse", "column-reverse"]),
  /** Justifies content when in `flex` based display modes */
  justifyContent: _propTypes["default"].oneOf(["flex-start", "flex-end", "center", "space-between", "space-around"]),
  /** Aligns self when inl a `flex` container */
  alignSelf: _propTypes["default"].oneOf(["flex-start", "flex-end", "center", "baseline", "stretch"]),
  /** Aligns items when in `flex` based display modes */
  alignItems: _propTypes["default"].oneOf(["flex-start", "flex-end", "center", "baseline", "stretch"]),
  /** Gap between items in `flex` based display modes */
  gap: _propTypes["default"].oneOf(_base.spaceTypes),
  /** Spacing used for `row-gap` */
  gapV: _propTypes["default"].oneOf(_base.spaceTypes),
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  borderRadius: _propTypes["default"].string,
  /** Display a border all around the box */
  b: _propTypes["default"].bool,
  /** Display a border on top of the box */
  bT: _propTypes["default"].bool,
  /** Display a border on the bottom of the box */
  bB: _propTypes["default"].bool,
  /** Display a border on the left side of the box */
  bL: _propTypes["default"].bool,
  /** Display a border on the right side of the box */
  bR: _propTypes["default"].bool,
  overflow: _propTypes["default"].oneOf(["auto", "hidden", "inherit", "scroll", "overlay", "visible", "revert", "initial", "unset"]),
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "inherit", "scroll", "overlay", "visible", "revert", "initial", "unset"]),
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "inherit", "scroll", "overlay", "visible", "revert", "initial", "unset"]),
  /**
   * CSS `position`
   *
   * [MDN documentation](https://developer.mozilla.org/en-US/docs/Web/CSS/position)
   */
  position: _propTypes["default"].oneOf(["static", "relative", "absolute", "fixed", "sticky"]),
  /** Participates in the vertical position of a _positioned_ element */
  top: _propTypes["default"].string,
  /** Participates in the horizontal position of a _positioned_ element */
  right: _propTypes["default"].string,
  /** Participates in the vertical position of a _positioned_ element */
  bottom: _propTypes["default"].string,
  /** Participates in the horizontal position of a _positioned_ element */
  left: _propTypes["default"].string,
  /** If this prop is true, the box will have the flex display mode
   *  and justify-content and align items will be set to `center`
   */
  center: _propTypes["default"].bool
};
var Box = _styledComponents["default"].div.withConfig({
  displayName: "Box",
  componentId: "sc-33bihu-0"
})(["", ";", ";", ";", ";display:", ";", ";", ";", " ", " ", " ", " ", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", " ", ";", ";", ";", ";", ";", ";border-color:", ";", ";", ";", ";"], _mixins.paddingMixin, _mixins.marginMixin, (0, _mixins.backgroundMixin)("transparent"), (0, _mixins.colorMixin)("inherit"), function (props) {
  return props.d || "block";
}, function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";"], props.w);
}, function (props) {
  return props.h && (0, _styledComponents.css)(["height:", ";"], props.h);
}, function (props) {
  return props.minW && (0, _styledComponents.css)(["min-width:", ";"], props.minW);
}, function (props) {
  return props.maxW && (0, _styledComponents.css)(["max-width:", ";"], props.maxW);
}, function (props) {
  return props.minH && (0, _styledComponents.css)(["min-height:", ";"], props.minH);
}, function (props) {
  return props.maxH && (0, _styledComponents.css)(["max-height:", ";"], props.maxH);
}, function (props) {
  return props.flex && (0, _styledComponents.css)(["flex:", ";"], props.flex);
}, function (props) {
  return props.wrap && (0, _styledComponents.css)(["flex-wrap:", ";"], props.wrap);
}, function (props) {
  return props.direction && (0, _styledComponents.css)(["flex-direction:", ";"], props.direction);
}, function (props) {
  return props.alignItems && (0, _styledComponents.css)(["align-items:", ";"], props.alignItems);
}, function (props) {
  return props.alignSelf && (0, _styledComponents.css)(["align-self:", ";"], props.alignSelf);
}, function (props) {
  return props.justifyContent && (0, _styledComponents.css)(["justify-content:", ";"], props.justifyContent);
}, function (props) {
  return props.gap && (0, _styledComponents.css)(["gap:", ";"], (0, _helpers.getSpace)(props, "gap", "base"));
}, function (props) {
  return props.gapV && (0, _styledComponents.css)(["row-gap:", ";"], (0, _helpers.getSpace)(props, "gapV", "base"));
}, function (props) {
  return props.center && (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;"]);
}, function (props) {
  return props.position && (0, _styledComponents.css)(["position:", ";"], props.position);
}, function (props) {
  return ["top", "right", "bottom", "left"].map(function (p) {
    return (0, _styledComponents.css)(["", ":", ";"], p, props[p]);
  });
}, function (props) {
  var _props$theme$borderRa;
  return props.borderRadius && (0, _styledComponents.css)(["border-radius:", ";"], (_props$theme$borderRa = props.theme.borderRadius[props.borderRadius]) !== null && _props$theme$borderRa !== void 0 ? _props$theme$borderRa : props.theme.borderRadius.base);
}, function (props) {
  return props.b && (0, _styledComponents.css)(["border:1px solid;"]);
}, function (props) {
  return props.bT && (0, _styledComponents.css)(["border-top:1px solid;"]);
}, function (props) {
  return props.bB && (0, _styledComponents.css)(["border-bottom:1px solid;"]);
}, function (props) {
  return props.bL && (0, _styledComponents.css)(["border-left:1px solid;"]);
}, function (props) {
  return props.bR && (0, _styledComponents.css)(["border-right:1px solid;"]);
}, function (props) {
  return (0, _helpers.getColor)(props, "borderColor", "border");
}, function (props) {
  return props.overflowX && (0, _styledComponents.css)(["overflow-x:", ";"], props.overflowX);
}, function (props) {
  return props.overflowY && (0, _styledComponents.css)(["overflow-y:", ";"], props.overflowY);
}, function (props) {
  return props.overflow && (0, _styledComponents.css)(["overflow:", ";"], props.overflow);
});
Box.propTypes = propTypes;
Box.displayName = "Box";
var _default = Box;
exports["default"] = _default;